import { msg } from '@lingui/core/macro';

export const SHARED_IMAGE_UPLOAD_MODAL_CURRENT_LABEL = msg`Current`;
export const SHARED_IMAGE_UPLOAD_MODAL_NEW_LABEL = msg`New`;
export const SHARED_IMAGE_UPLOAD_MODAL_DRAG_AND_DROP = msg`Click to upload or drag and drop`;
export const SHARED_IMAGE_UPLOAD_MODAL_CANCEL = msg`Cancel`;
